//@ts-nocheck
import { Center, Spinner } from "@chakra-ui/react";
import {
  Circle,
  GoogleMap,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import { MarkerLogoIcon } from "./MarkerLogo";
//@ts-nocheck
import { VStack } from "@chakra-ui/react";
import React from "react";
import { GetUseMapProps } from "./hooks";

type MapComponentProps = {
  marker: { lat: number; lng: number };
  onMapClick: () => void;
  onMapMounted: (map: any) => void;
  onDragEnd: (coordinate: { latitude: number; longitude: number }) => void;
  containerElement?: (children?: any) => React.ReactNode;
  mapContainerStyle?: any;
};

const libraries = ["places", "geometry"];

const MAP = (props: MapComponentProps) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyAGzhm0XKSODtV3cBmytMp5eN1yTeLBcmA",
    region: "Lekki",
    libraries,
    version: "weekly",
  });
  const { marker, onDragEnd, onMapClick, onMapMounted, containerElement } =
    props as MapComponentProps;

  const children = isLoaded ? (
    <GoogleMap
      onLoad={(map) => {
        const bounds = new window.google.maps.LatLngBounds();
        map.fitBounds(bounds);
        onMapMounted(map);
      }}
      zoom={18}
      mapContainerStyle={props.mapContainerStyle}
      center={marker}
      onClick={onMapClick}
    >
      <Marker
        position={marker}
        defaultAnimation={2}
        draggable={true}
        icon={MarkerLogoIcon}
        onDragEnd={({ latLng }: any) => {
          const latitude = latLng.lat();
          const longitude = latLng.lng();
          onDragEnd({ latitude, longitude });
        }}
      />
      <Circle
        center={marker}
        radius={50}
        options={{
          fillColor: `#36D37E`,
          fillOpacity: 0.29,
          strokeColor: `#36D37E`,
          strokeOpacity: 1,
          strokeWeight: 2,
        }}
      />
    </GoogleMap>
  ) : (
    <Center width="full" height="540px">
      <Spinner boxSize={24} borderColor="green.500" thickness="8px" />
    </Center>
  );
  if (containerElement) {
    return containerElement(children);
  }
  return children;
};

const ContainerElement: React.FC<{
  formRender?: any;
  children: any;
  displayMap?: boolean;
}> = ({ children, formRender, displayMap }) => {
  return (
    <VStack>
      {formRender}
      {displayMap ? children : null}
    </VStack>
  );
};

interface MapFormComponentProps extends GetUseMapProps {
  children?: any;
  displayMap?: boolean;
  containerElement?: (displayMap: boolean, children: any) => React.ReactNode;
  location: any;
  mapContainerStyle?: any;
}
export const MapFormComponent: React.FC<MapFormComponentProps> = ({
  onMapMount,
  onDragEnd,
  location,
  displayMap,
  children,
  mapContainerStyle,
  containerElement = (displayMap, children) => (
    <ContainerElement
      displayMap={displayMap}
      formRender={children}
    ></ContainerElement>
  ),
}) => {
  const hasCoordinates = location.latitude && location.longitude;
  return (
    <MAP
      containerElement={() =>
        containerElement(displayMap ? hasCoordinates : false, children)
      }
      mapContainerStyle={mapContainerStyle}
      onMapClick={() => {}}
      onMapMounted={onMapMount}
      onDragEnd={onDragEnd}
      marker={{ lat: location.latitude, lng: location.longitude }}
      //   onMarkerRightClick={() => {}}
    />
  );
};

export default MapFormComponent;
